import { useUploadKeepAwake } from "@/hooks/useUploadStatus"

/**
 * Keeps the screen on during a large upload, app-wide: the queue is shared by
 * every project, so this can't live inside one project's route.
 */
export function UploadKeepAwake() {
  useUploadKeepAwake()
  return null
}
